import { useEffect } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";

import {
  verifyToken,
  verifyTokenResetPassword,
} from "services/AuthenticationService";
import { useAppDispatch } from "store/store";
import { setVerificationType } from "store/slicer/tokenVerificationSlice";
import { GenericLandingCard } from "../components";
import { setActivationToken } from "store/slicer/tokenSlice";

export const MaskSetPasswordPage = () => {
  const location = useLocation();

  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (token) {
      if (location.pathname === "/check-token") {
        verifyToken(token)
          .then(() => {
            dispatch(setVerificationType("registration"));
            dispatch(setActivationToken(token));
            navigate("/set-password");
          })
          .catch(() => navigate("/expired-link"));
      } else if (location.pathname === "/check-token-reset-password") {
        verifyTokenResetPassword(token)
          .then(() => {
            dispatch(setVerificationType("passwordReset"));
            dispatch(setActivationToken(token));
            navigate("/set-password");
          })
          .catch(() => navigate("/expired-link"));
      }
    } else {
      navigate("/");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return <GenericLandingCard />;
};
